<template>
  <Card shoaw class="job-edit">
    <div class="content">
      <div class="" id="job-edit-main">
        <Modal title="选择脚本" v-model="selectScriptModal">
          <Select v-model="copyScript" filterable>
            <Option v-for="item in allScriptList" :value="item.id" :key="item.id">{{ item.name }}</Option>
          </Select>
          <div slot="footer">
            <Button type="primary" :loading="selectScriptLoading" style="margin-right: 8px" @click="selectScriptOk">确定</Button>
            <Button @click="selectScriptModal = false">取消</Button>
          </div>
        </Modal>
        <SelectServer ref="SelectServer" v-on:selectServerComplete="selectServerComplete"></SelectServer>
        <Row class="title">
          <h4 :style="{float: 'left'}">{{ title }}</h4>
        </Row>
        <Alert v-if="jobError" type="warning" show-icon>获取作业数据失败</Alert>
        <Form ref="jobForm" :model="jobForm" :label-width="70" :rules="jobRule" v-else>
          <FormItem label="作业名称" prop="name">
            <Input v-model="jobForm.name" :maxlength="100" />
          </FormItem>
          <FormItem label="作业描述" prop="desc">
            <Input v-model="jobForm.desc" :maxlength="1000" type="textarea" />
          </FormItem>
          <FormItem label="步骤" ref="stepRef">
            <Card style="margin-bottom: 10px" v-for="(step, index) in steps" :key="index">
              <div slot="title" style="height: 14px">
                <div style="float: left; height: 14px">
                  <Icon type="md-list-box" />
                  <span> 步骤{{ index + 1 }}</span>
                </div>
                <div style="float: right; height: 14px">
                  <i-switch v-model="step.show" size="large">
                    <span slot="open">详细</span>
                    <span slot="close">折叠</span>
                  </i-switch>
                  <Tooltip content="上移" style="margin-left: 15px">
                    <a v-on:click="stepAction('up', index)">
                      <Icon type="md-arrow-up" size="19" />
                    </a>
                  </Tooltip>
                  <Tooltip content="下移" style="margin-left: 10px">
                    <a v-on:click="stepAction('down', index)">
                      <Icon type="md-arrow-down" size="19" />
                    </a>
                  </Tooltip>
                  <Tooltip content="删除步骤" style="margin-left: 10px">
                    <a v-on:click="stepAction('close', index, step.stepType)">
                      <Icon type="md-close" size="19" />
                    </a>
                  </Tooltip>
                </div>
              </div>
              <div>
                <Form :ref="'stepForm'" :model="step" inline :label-width="70" label-position="left" :rules="stepRule">
                  <FormItem label="步骤名称" prop="stepName">
                    <Input v-model="step.stepName" style="min-width: 168px" :maxlength="128" placeholder="请填写步骤名称" />
                  </FormItem>
                  <FormItem label="完成后是否暂停" :label-width="100">
                    <i-switch v-model="step.is_suspend">
                      <span slot="open">是</span>
                      <span slot="close">否</span>
                    </i-switch>
                  </FormItem>
                  <FormItem label="是否跳过错误" :label-width="100">
                    <i-switch v-model="step.is_jump_error">
                      <span slot="open">是</span>
                      <span slot="close">否</span>
                    </i-switch>
                  </FormItem>
                  <FormItem label="完成后延迟时间(秒)" :label-width="130" prop="delay">
                    <InputNumber v-model="step.delay" style="width:150px" :min="0" />
                  </FormItem>
                  <div :class="{'circle-step-type': true, 'circle-step-type-script': step.stepType === 'script',
                  'circle-step-type-message': step.stepType === 'message' }" style="float: right">
                    <span class="step-type-span" v-if="step.stepType === 'script'">脚本</span>
                    <span class="step-type-span" v-else-if="step.stepType === 'message'">消息</span>
                  </div>
                  <div v-if="step.stepType === 'script'" v-show="step.show">
                    <Divider dashed></Divider>
                    <FormItem label="脚本名称" prop="name">
                      <Input v-model="step.name" style="min-width: 168px" :maxlength="100" placeholder="请填写脚本名称" />
                    </FormItem>
                    <FormItem label="脚本参数" prop="scriptParams">
                      <Input v-model="step.params" style="min-width: 168px" :maxlength="100" placeholder="请填写脚本参数" />
                    </FormItem>
                    <FormItem label="用户凭证" prop="certificate">
                      <Select v-model="step.certificate" style="min-width:168px" placeholder="请选择目标服务器上存在的用户凭证" filterable>
                        <Option v-for="item in allCertificateList" :value="item.id" :key="item.id">{{ item.name }}</Option>
                      </Select>
                    </FormItem>
                    <Row style="margin-top: 10px">
                      <FormItem label="脚本" prop="type">
                        <RadioGroup v-model="step.type" @on-change="v=>{ typeChange(v, index)}">
                          <Radio :label="sItem.value" v-for="(sItem, sIndex) in allTypeData" :key="sIndex">{{ sItem.label }}</Radio>
                        </RadioGroup>
                      </FormItem>
                      <Button type="primary" size="small" style="float: right;" @click="openSelectScriptModal(index)">拷贝已有脚本</Button>
                    </Row>
                    <FormItem prop="content" style="display: block">
                      <codemirror :ref="'script_content'" v-model="step.content" :options="cmOptions" style=""></codemirror>
                    </FormItem>
                    <Row style="margin-top: 10px">
                      <FormItem :label="'目标服务器(' + step.targetsLength + ')'" :label-width="130" prop="targetsLength">
                        <Button type="default" icon="ios-desktop-outline" @click="openSelectServerModal(index)" v-if="!step.targetsLength">选择目标服务器</Button>
                        <a v-on:click="openSelectServerModal(index)" v-else>继续选择目标服务器 </a>
                        <br />
                        <Tag color="primary" v-for="(tValue, tKey, tIndex) in step.targets" :key="'target_hostname_' + index + '_' + tIndex" v-if="tValue">{{ tKey }}</Tag>
                      </FormItem>
                    </Row>
                  </div>
                  <div v-else-if="step.stepType === 'message'" v-show="step.show">
                    <Divider dashed></Divider>
                    <FormItem label="消息标题" prop="title">
                      <Input v-model="step.title" style="width: 250px" :maxlength="128" placeholder="请填写消息标题" />
                    </FormItem>
                    <FormItem label="消息类型" prop="type">
                      <RadioGroup v-model="step.type">
                        <Radio :label="item.value" v-for="(item, index) in allMsgTypeData" :key="index">{{ item.label }}</Radio>
                      </RadioGroup>
                    </FormItem>
                    <FormItem label="收件人" prop="targets">
                      <Select v-model="step.targets" multiple placeholder="请选择收件人">
                        <Option v-for="item in userList" :value="item.id" :key="item.id">{{ item.name }}</Option>
                      </Select>
                    </FormItem>
                    <FormItem label="消息内容" style="width: 100%; margin-top: 13px" prop="content">
                      <Input v-model="step.content" :maxlength="2000" placeholder="请填写消息内容" type="textarea" :rows="4" />
                    </FormItem>
                  </div>
                </Form>
              </div>
            </Card>
            <Dropdown trigger="click" @on-click="addStep">
              <Button type="primary" icon="md-add">添加步骤</Button>
              <DropdownMenu slot="list">
                <DropdownItem v-for="item in stepTypeList" :name="item.value" :key="item.value">{{ item.label }}</DropdownItem>
              </DropdownMenu>
            </Dropdown>
          </FormItem>
          <FormItem>
            <div style="float: right;">
              <Button type="primary" @click="jobSubmit" :loading="jobSubmitting">提交</Button>
              <Button style="margin-left: 8px" @click="$router.go(-1)">取消</Button>
            </div>
          </FormItem>
        </Form>
      </div>
    </div>
  </Card>
</template>

<script>
import { changeOpsCenterJob, getOpsCenterAllCertificate, getOpsCenterAllScript, detailOpsCenterScript,
  updateOpsCenterJobStep, detailOpsCenterJob, getOpsCenterJobSteps } from '@/api/opscenter'
import { GetALLUsers } from '@/api/user'
import codemirror from '../scriptUse.js'
import 'codemirror/addon/hint/show-hint.css'
import 'codemirror/addon/hint/show-hint.js'
import 'codemirror/addon/fold/foldgutter.css'
import 'codemirror/addon/fold/foldgutter.js'
import 'codemirror/addon/fold/foldcode.js'
import 'codemirror/addon/edit/closebrackets.js' // 自动闭合符号
import 'codemirror/addon/edit/matchbrackets.js' // 匹配结束符号，比如"]、}"
import { cmOptions, scriptTypeChange, getJsonLength } from '../scriptTools'
import SelectServer from '../select-server'

export default {
  name: 'job-edit',
  components: {
    codemirror,
    SelectServer
  },
  data () {
    return {
      title: '添加作业',
      jobError: false,
      jobForm: {
        id: 0,
        name: '',
        desc: ''
      },
      jobRule: {
        name: { required: true, message: '作业名称不能为空', trigger: 'blur' }
      },
      stepRule: {
        stepName: { required: true, message: '步骤名称不能为空', trigger: 'blur' },
        delay: { required: true, validator: this.validNumberRule, message: '延迟时间不能为空', trigger: 'blur' },
        name: { required: true, message: '名称不能为空', trigger: 'blur' },
        certificate: { required: true, type: 'number', message: '用户凭证不能为空', trigger: 'change' },
        content: { required: true, message: '内容不能为空', trigger: 'blur' },
        type: { required: true, message: '请选择类型', trigger: 'change' },
        title: { required: true, message: '标题不能为空', trigger: 'blur' },
        targets: [
          { required: true, type: 'array', min: 1, message: '请选择目标', trigger: 'change' }
        ],
        targetsLength: [
          { required: true, type: 'array', validator: this.validArrayRule, min: 1, message: '请选择目标服务器', trigger: 'change' }
        ]
      },
      jobSubmitting: false,
      // 脚本
      allTypeData: [
        { 'value': 'shell', 'label': 'shell' },
        { 'value': 'python', 'label': 'python' },
        { 'value': 'linuxyml', 'label': 'linux-yml' },
        { 'value': 'winyml', 'label': 'win-yml' },
        { 'value': 'winps1', 'label': 'powershell' }
      ],
      stepTypeList: [
        { value: 'script', label: '执行脚本' },
        // { value: 'sql', label: '执行SQL' },
        // { value: 'file', label: '分发文件' },
        { value: 'message', label: '推送消息' }
      ],
      allCertificateList: [],
      allScriptList: [],
      selectScriptModal: false,
      currentStepIndex: 0,
      copyScript: '',
      selectScriptLoading: false,
      // 消息
      allMsgTypeData: [
        // { 'value': 'IM', 'label': 'IM' },
        // { 'value': 'sms', 'label': '短信' },
        { 'value': 'email', 'label': '邮件' }
      ],
      userList: [],
      stepsError: false,
      steps: [],
      stepsRule: {},
      cmOptions: cmOptions
    }
  },
  created: function () {
    this.init()
    this.getAllUserData()
  },
  watch: {
    'steps': function () {
      this.$nextTick(function () {
        let scriptLen = 0
        for (let c in this.steps) {
          if (this.steps[c].stepType === 'script') {
            let editor = this.$refs.script_content[scriptLen].editor
            editor.on('keypress', function () { // 监听输入，自动弹出代码智能提示
              editor.showHint({
                completeSingle: false // 关闭在只有一个选项时自动完成拼写
              })
            })
            const lang = scriptTypeChange(this.steps[c].type)
            editor.setOption('mode', { name: lang })
            scriptLen += 1
          }
        }
      })
    }
  },
  methods: {
    // 初始化
    init () {
      this.getAllCertificate()
      this.allScript()
      if (this.$route.params.id) {
        this.getData()
        this.getJobStepsData()
      } else {
        this.addStep('script')
      }
    },
    // 获取作业数据
    getData () {
      this.jobError = false
      detailOpsCenterJob(this.$route.params.id).then(res => {
        this.jobForm.id = res.data.id
        this.jobForm.name = res.data.name
        this.jobForm.desc = res.data.desc
      }).catch(res => {
        this.jobError = true
        this.$Notice.error({ title: '获取作业数据失败' })
      })
    },
    // 获取作业步骤
    getJobStepsData () {
      this.stepsError = false
      getOpsCenterJobSteps({ job: this.$route.params.id }).then(res => {
        for (let i in res.data) {
          let result = res.data[i]
          let baseStep = {
            id: result.id,
            stepName: result.name,
            stepType: result.type,
            delay: result.delay,
            is_suspend: result.is_suspend,
            is_jump_error: result.is_jump_error,
            show: false
          }
          if (result.type === 'script' && result.job_script_step.length) {
            let script = result.job_script_step[0]
            baseStep['name'] = script.name
            baseStep['type'] = script.type
            baseStep['content'] = script.content
            baseStep['params'] = script.params
            if (script.certificate) {
              baseStep['certificate'] = script.certificate
            } else {
              baseStep['certificate'] = ''
            }
            baseStep['targets'] = script.server_ids
            baseStep['targetsLength'] = getJsonLength(script.server_ids)
            this.steps.push(baseStep)
          } else if (result.type === 'message') {
            let message = result.job_message_step[0]
            baseStep['title'] = message.title
            baseStep['type'] = message.type
            baseStep['content'] = message.content
            baseStep['targets'] = message.targets
            this.steps.push(baseStep)
          }
        }
      }).catch(res => {
        this.stepsError = true
        this.$Notice.error({ title: '获取作业步骤数据失败' })
      })
    },
    // 作业提交
    jobSubmit () {
      let allValid = true
      this.$refs['jobForm'].validate((valid) => {
        if (!valid) {
          allValid = false
        }
      })
      for (let i in this.$refs['stepForm']) {
        this.$refs['stepForm'][i].validate((valid) => {
          if (!valid) {
            allValid = false
          }
        })
      }
      if (allValid) {
        this.jobSubmitting = true
        changeOpsCenterJob(this.jobForm, this.jobForm.id).then(res => {
          const result = res.data
          const job = result.id
          let reqData2 = {
            job: job,
            steps: this.steps
          }
          updateOpsCenterJobStep(reqData2).then(res2 => {
            this.$router.push({ name: 'job_detail', params: { id: job } })
            this.jobSubmitting = false
            this.$Notice.success({ title: '操作成功！' })
          }).catch(res2 => {
            this.jobSubmitting = false
            if (res2.request) {
              this.$Notice.error({
                title: '提交作业步骤失败！',
                desc: res2.request.responseText
              })
            } else {
              this.$Notice.error({
                title: '提交作业步骤失败'
              })
            }
          })
        }).catch(res => {
          this.jobSubmitting = false
          if (res.request) {
            this.$Notice.error({
              title: '提交作业失败！请求状态码:' + res.request.status,
              desc: res.request.responseText
            })
          } else {
            this.$Notice.error({
              title: '提交作业失败'
            })
          }
        })
      } else {
        this.$Notice.error({
          title: '表单未填写完整，请检查输入框！'
        })
      }
    },
    // 步骤操作：上移/下移/删除
    stepAction (name, index) {
      switch (name) {
        case 'up':
          if (index !== 0) {
            let ss = this.steps
            let a = ss[index - 1]
            ss[index - 1] = ss[index]
            ss[index] = a
            this.steps = []
            this.steps = ss
          }
          break
        case 'down':
          if (index + 1 < this.steps.length) {
            let ss = this.steps
            let a = ss[index + 1]
            ss[index + 1] = ss[index]
            ss[index] = a
            this.steps = []
            this.steps = ss
          }
          break
        case 'close':
          this.steps.splice(index, 1)
          break
      }
    },
    // 添加步骤
    addStep (type, id = 0) {
      let baseStep = {
        id: id,
        stepName: '',
        stepType: 'script',
        delay: 0,
        is_suspend: false,
        is_jump_error: false,
        show: true
      }
      for (let i in this.steps) {
        this.steps[i].show = false
      }
      switch (type) {
        case 'script':
          baseStep['stepType'] = 'script'
          baseStep['name'] = ''
          baseStep['type'] = 'shell'
          baseStep['content'] = ''
          baseStep['params'] = ''
          baseStep['certificate'] = ''
          baseStep['targets'] = []
          baseStep['targetsLength'] = 0
          break
        case 'sql':
          break
        case 'file':
          break
        case 'message':
          baseStep['stepType'] = 'message'
          baseStep['title'] = ''
          baseStep['type'] = 'email'
          baseStep['content'] = ''
          baseStep['targets'] = []
          break
      }
      this.steps.push(baseStep)
    },
    // 获取所有凭证列表
    getAllCertificate () {
      getOpsCenterAllCertificate().then(res => {
        this.allCertificateList = res.data
      })
    },
    // 获取所有脚本列表
    allScript () {
      getOpsCenterAllScript().then(res => {
        this.allScriptList = res.data
      }).catch(res => {
        if (res.request) {
          this.$Notice.error({
            title: '获取脚本列表失败！请求状态码:' + res.request.status,
            desc: res.request.responseText
          })
        } else {
          this.$Notice.error({
            title: '获取脚本列表失败'
          })
        }
      })
    },
    // 打开选中脚本Modal
    openSelectScriptModal (index) {
      this.currentStepIndex = index
      this.selectScriptModal = true
    },
    // 选择脚本完成
    selectScriptOk () {
      detailOpsCenterScript(this.copyScript).then(res => {
        const result = res.data
        this.steps[this.currentStepIndex].type = result.type
        this.steps[this.currentStepIndex].content = result.content
        this.steps[this.currentStepIndex].name = result.name
        this.typeChange(result.type, this.currentStepIndex)
        this.selectScriptModal = false
        this.copyScript = ''
      }).catch(res => {
        if (res.request) {
          this.$Notice.error({
            title: '拷贝脚本数据失败！请求状态码:' + res.request.status,
            desc: res.request.responseText
          })
        } else {
          this.$Notice.error({
            title: '拷贝脚本数据失败'
          })
        }
      })
    },
    // 脚本类型修改触发
    typeChange (value, index) {
      let tScriptLen = 0
      for (let v in this.steps) {
        if (this.steps[v].stepType === 'script') {
          if (index + '' === v) {
            break
          }
          tScriptLen += 1
        }
      }
      const lang = scriptTypeChange(value)
      this.$refs.script_content[tScriptLen].editor.setOption('mode', { name: lang })
    },
    // 打开服务器选择Modal
    openSelectServerModal (index) {
      this.$refs.SelectServer.openSelectServerModal({}, this.steps[index].targets, index)
    },
    // 选择服务器完成回调
    selectServerComplete (server, length, index) {
      this.steps[index].targets = server
      this.steps[index].targetsLength = length
    },
    // 获取所有用户列表
    getAllUserData () {
      GetALLUsers().then(res => {
        this.userList = res.data
      }).catch(errO => {
        this.$Notice.error({
          title: '获取用户列表失败！'
        })
      })
    },
    // 数字校验器
    validNumberRule (rule, value, callback) {
      if (value === null) {
        callback(new Error())
      } else {
        callback()
      }
    },
    // 数组校验器
    validArrayRule (rule, value, callback) {
      if (value === 0) {
        callback(new Error())
      } else {
        callback()
      }
    }
  }
}
</script>

<style lang="less">
  @import '../base.less';
  .CodeMirror{
    font-size: 15px;
  }
  .CodeMirror-gutters {
    /*border-left: 4px solid #9A9A9A;*/
  }
  .CodeMirror-fullscreen {
    z-index: 999 !important;
  }
  .CodeMirror-hints {
    z-index: 1000 !important;
  }
  #job-edit-main .circle-step-type {
    line-height: 50px;
    width: 50px;
    height: 50px;
    border-radius: 50%;
    -moz-border-radius: 50%;
    -webkit-border-radius: 50%;
    margin: 4px;
    text-align: center;
  }
  #job-edit-main .circle-step-type-script {
    background-color: #2d8cf0;
  }
  #job-edit-main .circle-step-type-message {
    background-color: #19be6b;
  }
  #job-edit-main .step-type-span{
    color: #ffffff;
    font-size: 17px;
    line-height: 50px;
  }
</style>
<style lang="less" scoped>
.ivu-form-item-error-tip{
  position: inherit!important;
}
</style>
